import errorMessage_zh from './errorMessage_zh';

const locale_zh = {
	Internet_banking: '網上銀行',
	hsbc_logo: '滙豐香港 銀行服務',
	timeout_title: '您本次登錄即將完結，要保持登錄吗？',
	timeout_quit: '登出',
	timeout_continue: '保持登錄',
	homeTitle: '理財管理系统',
	footer_copyright: "© 版權所有。香港上海汇丰銀行有限公司 2002-{endYear}。不得轉載。",
	design_for_hk: "本網站為於香港使用而設計。",
	cross_border: "<a href='https://www.hsbc.com.hk/zh-hk/digital/cross-border-banking/' target='_blank'>跨境披露聲明</a>",
	customer_landing: '歡迎您回來, ',
	hello : '歡迎光臨, QY!',
	superHello : '歡迎光臨, { someone } !',
	Collapse_Menu: '收起選單',
	...errorMessage_zh
};

export default locale_zh;
